const Call = () => {
  return (
    <svg
      width="37"
      height="37"
      viewBox="0 0 37 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.835938"
        y="0.270508"
        width="36"
        height="36"
        rx="8"
        fill="#006694"
      />
      <g clip-path="url(#clip0_10958_88225)">
        <path
          d="M15.8195 15.6483C16.3995 16.8563 17.1902 17.9885 18.1915 18.9898C19.1928 19.9911 20.325 20.7818 21.533 21.3618C21.6369 21.4117 21.6889 21.4366 21.7546 21.4558C21.9882 21.5239 22.2751 21.475 22.473 21.3333C22.5287 21.2934 22.5763 21.2458 22.6715 21.1506C22.9629 20.8592 23.1086 20.7135 23.255 20.6183C23.8074 20.2591 24.5196 20.2591 25.072 20.6183C25.2185 20.7135 25.3642 20.8592 25.6555 21.1506L25.8179 21.3129C26.2608 21.7558 26.4822 21.9772 26.6025 22.2151C26.8417 22.688 26.8417 23.2466 26.6025 23.7196C26.4822 23.9574 26.2608 24.1788 25.8179 24.6217L25.6865 24.753C25.2452 25.1944 25.0245 25.4151 24.7245 25.5836C24.3915 25.7706 23.8745 25.9051 23.4926 25.904C23.1485 25.9029 22.9133 25.8362 22.4429 25.7027C19.9151 24.9852 17.5298 23.6315 15.5398 21.6415C13.5498 19.6515 12.1961 17.2662 11.4786 14.7384C11.3451 14.268 11.2784 14.0328 11.2774 13.6887C11.2762 13.3068 11.4107 12.7898 11.5977 12.4568C11.7662 12.1568 11.9869 11.9361 12.4283 11.4948L12.5596 11.3634C13.0025 10.9206 13.2239 10.6991 13.4618 10.5788C13.9347 10.3396 14.4933 10.3396 14.9662 10.5788C15.2041 10.6991 15.4255 10.9206 15.8684 11.3634L16.0308 11.5258C16.3221 11.8172 16.4678 11.9628 16.563 12.1093C16.9222 12.6617 16.9222 13.3739 16.563 13.9263C16.4678 14.0728 16.3221 14.2184 16.0308 14.5098C15.9355 14.605 15.8879 14.6527 15.848 14.7083C15.7063 14.9062 15.6574 15.1931 15.7255 15.4267C15.7447 15.4924 15.7696 15.5444 15.8195 15.6483Z"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_10958_88225">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(8.83594 8.27051)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Call;
